<template>
	<div>
		<!-- 搜索按钮 -->
		<el-button class="search-btn" type="primary" @click="Search">{{translate.ShowText('搜索')}}</el-button>
	</div>
</template>

<script lang="ts" setup>
	const emits = defineEmits(["change"]);
	import translate from '@/api/translate';

	const Search = () => {
		emits("change");
	};
</script>

<style lang="scss" scoped>
	.search-btn {
		padding: 0 12px;
		// width: 60px;
		height: 32px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 32px;
	}
</style>